import React from 'react';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import TopLevelErrorBoundary from './components/errorHandlers/TopLevelErrorBoundary';
import Map from './components/Map/Map';
import './App.css';
import FullPageSpinner from './components/App/FullPageSpinner';
import { newBuSTheme } from './styling/theme';
import useMarketData from './hooks/useMarketData';
import { LoadingStates } from './types';

const App = () => {
  // Fetch data from the Strapi backend
  const [marketData, loadingStatusMarketData] = useMarketData();

  let loadingStatus: LoadingStates;
  if (loadingStatusMarketData === 'completed') {
    loadingStatus = 'completed';
  } else if (loadingStatusMarketData === 'error') {
    loadingStatus = 'error';
  } else {
    loadingStatus = 'loading';
  }

  return (
    <TopLevelErrorBoundary>
      <ThemeProvider theme={newBuSTheme}>
        <CssBaseline />
        {loadingStatus === 'loading' && <FullPageSpinner />}
        {loadingStatus === 'error' && (
          <p>There was an error loading the data</p>
        )}
        {loadingStatus === 'completed' && <Map marketData={marketData} />}
      </ThemeProvider>
    </TopLevelErrorBoundary>
  );
};

export default App;
